import React from "react";
import LiquidationWorkflow from "../accounting/LiquidationWorkflow";

const RequestorLiquidationReport = () => (
  <LiquidationWorkflow
    portalLabel="Requestor Portal"
    pageTitle="Liquidation Report"
    pageDescription="Review liquidation records and supporting documents for the requests you created."
    scope="created"
    hideReportEditor={false}
  />
);

export default RequestorLiquidationReport;
